/**
 * Device-aware store links.
 * - Apple: desktop → web URL; iOS/iPad → App Store app (itms-apps)
 * - Google Play: desktop → web URL; Android → Play Store app (market://)
 */

const APPLE_WEB = 'https://apps.apple.com/us/app/begin-strength/id6757798183';
const APPLE_APP = 'itms-apps://itunes.apple.com/app/id6757798183';
const GOOGLE_WEB = 'https://play.google.com/store/apps/details?id=com.beginstrength.app';
const GOOGLE_APP = 'market://details?id=com.beginstrength.app';

function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ Safari reports as Macintosh
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  return false;
}

function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/.test(navigator.userAgent);
}

export function getAppleStoreUrl() {
  return isIOS() ? APPLE_APP : APPLE_WEB;
}

export function getGooglePlayUrl() {
  return isAndroid() ? GOOGLE_APP : GOOGLE_WEB;
}
